import React from 'react';

import { Button, Chip, Stack, Typography } from '@gogame/components';
import { withFormField, FormErrorMessage } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import { VALUE_FORMULA } from 'scenes/SmartRules/SmartRuleForm/Conditions';

import { VALUE } from '../../ModifyAction';
import { FormulaForm } from './FormulaForm';

export const FormulaField = withFormField()(({
  area,
  active,
  value,
  onChange,
}) => {
  const metricsOptions = area.data?.metrics;

  const [childComponent, openChildComponent] = useChildComponent();

  const handleClickSetFormula = React.useCallback(() => {
    openChildComponent(FormulaForm, {
      metrics: metricsOptions,
      initialValues: {
        [VALUE_FORMULA]: { formula: value },
      },
      onSubmit: ({ [VALUE_FORMULA]: valueFormula }) => {
        onChange(null, valueFormula.formula);
      },
    });
  }, [metricsOptions, value]);

  return (
    <React.Fragment>
      <Stack direction={'row'}>
        {value ? (
          <Chip
            style={{ maxWidth: 250 }}
            label={
              <Typography component={'span'} noWrap={true}>
                {value}
              </Typography>
            }
          />
        ) : null}
        <Button
          add
          onClick={handleClickSetFormula}
          disabled={!(active && metricsOptions)}
        >
          formula text
        </Button>
      </Stack>

      <FormErrorMessage name={VALUE} />
      {childComponent}
    </React.Fragment>
  );
});
